import React from 'react';

const Trust = () => {
  return (
    <section className="py-16 bg-white border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-sm font-medium text-slate-500 uppercase tracking-widest mb-8">
          Used by professionals planning their financial future
        </p>
        <div className="flex flex-wrap justify-center gap-8 md:gap-16 opacity-40 grayscale hover:grayscale-0 transition-all duration-300">
          {/* Simulated company logos using simple text for styling */}
          <div className="text-xl font-bold tracking-tighter text-slate-800">AcmeCorp</div>
          <div className="text-xl font-black italic text-slate-800">GlobalTech</div>
          <div className="text-xl font-serif font-bold text-slate-800">NEXUS</div>
          <div className="text-xl font-light tracking-widest text-slate-800">VANGUARD</div>
          <div className="text-xl font-bold tracking-tight text-slate-800">Stratos</div>
        </div>
      </div>
    </section>
  );
};

export default Trust;